import React from 'react';
import { X, Smartphone, FileText } from 'lucide-react';

const PositionModal = ({ 
  setActiveModal, 
  positionData, 
  setPositionData, 
  getGPSPosition, 
  logPosition 
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">Log Position</h3>
      <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-600">
        <X className="h-5 w-5" />
      </button>
    </div>
    
    <div className="space-y-4">
      <div className="flex gap-2 mb-4">
        <button
          onClick={getGPSPosition}
          className="flex-1 px-4 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 flex items-center justify-center gap-2"
        >
          <Smartphone className="h-4 w-4" />
          Use GPS
        </button>
        <button
          onClick={() => setPositionData({...positionData, source: 'manual'})}
          className={`flex-1 px-4 py-2 rounded-lg flex items-center justify-center gap-2 ${
            positionData.source === 'manual' ? 'bg-gray-200 text-gray-800' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          <FileText className="h-4 w-4" />
          Manual Entry
        </button>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Latitude</label>
        <input
          type="text"
          value={positionData.lat}
          onChange={(e) => setPositionData({...positionData, lat: e.target.value})}
          placeholder="e.g., 51.5074"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Longitude</label>
        <input
          type="text"
          value={positionData.lon}
          onChange={(e) => setPositionData({...positionData, lon: e.target.value})}
          placeholder="e.g., -0.1278"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div className="text-xs text-gray-500">
        {positionData.source === 'gps' && '📍 Position obtained from device GPS'}
        Position will be logged as: {positionData.lat || '__'}°, {positionData.lon || '__'}°
      </div>
      
      <div className="flex gap-2 pt-4">
        <button
          onClick={() => setActiveModal(null)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={logPosition}
          disabled={!positionData.lat || !positionData.lon}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          Log Position
        </button>
      </div>
    </div>
  </div>
);

export default PositionModal;